import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EnforcementService } from 'src/app/core/services/enforcement.service';


interface AssessmentAccount {
  mde_name: string;
  mde_questionaireaccountsid: string;
}

@Component({
  selector: 'app-enforcement-select',
  templateUrl: './enforcement-select.component.html',
  styleUrls: ['./enforcement-select.component.css']
})
export class EnforcementSelectComponent implements OnInit {
  isArabic!: boolean;
  assessmentAccounts: AssessmentAccount[] = [];
  form!: FormGroup;
  enforcementList: any[] = [];
  userData: any;
 
  constructor(
    private router: Router,
    private storageService: StorageService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private enforcementService: EnforcementService
  ) {}

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userData = this.storageService.getSessionStorageData('userDetails');
    this.form = this.fb.group({
      enforcement: [''] // default empty
    });
    const requestData = {
      assessmentUnitGuid: this.userData?.assessmentUnitValue,
    };
    this.enforcementService.fetchEnforcementList(requestData).subscribe((res) => {
      if (res?.data) {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        this.enforcementList = resp;
        if (this.enforcementList.length > 0) {
          this.storageService.setSessionStorageData('enforcementCount', this.enforcementList.length);
          this.form.patchValue({
            enforcement: this.enforcementList[0].mde_questionaireaccountsid
          });
        } else {
          this.form.patchValue({ enforcement: '' });
        }
      }
    }, 
    (error: any) => { 
      console.error('Error fetching enforcement list', error);
      this.form.patchValue({ enforcement: '' });
    });
  }

  goToDetail() {
    const selectedId = this.form.get('enforcement')?.value;
    this.storageService.setSessionStorageData('enforcementId', selectedId);
    this.storageService.removeSessionStorageData('isHistorical');
    if (selectedId) {
      this.router.navigate(
        ['/executor-dashboard/enforcement/detail'],
        { state: { enforcementId: selectedId , isHistorical: false} }
      );
    } else {
      alert('Please select an assessment first.');
    }
  }
}
